/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Strategy UI one-time code request
 */
export interface StrategySessionRequest {
  /**
   * Strategy subaccount ID
   */
  accountId: number;
}
